export const heroImage =
  "https://readdy.ai/api/search-image?query=Stylized%20anime%20illustration%20of%20a%20bustling%20city%20skyline%20at%20warm%20golden%20sunset%2C%20a%20young%20hero%20standing%20on%20a%20rooftop%20looking%20at%20distant%20glowing%20stars%2C%20vibrant%20manga%20art%20style%2C%20dynamic%20composition%2C%20warm%20orange%20amber%20and%20coral%20color%20palette%2C%20cinematic%20depth%2C%20detailed%20anime%20background%20art%2C%20atmospheric%20light%20rays%2C%20no%20text&width=1600&height=900&seq=comic-hero-2026&orientation=landscape";

export const communityImage =
  "https://readdy.ai/api/search-image?query=Cozy%20anime%20style%20illustration%20of%20friends%20reading%20comics%20together%20around%20a%20warm%20table%20at%20golden%20evening%20light%2C%20happy%20and%20relaxed%20atmosphere%2C%20warm%20coral%20and%20amber%20tones%2C%20slice%20of%20life%20manga%20art%2C%20detailed%20background%20with%20books%20and%20warm%20lamps%2C%20no%20text&width=1200&height=900&seq=comic-community-2026&orientation=landscape";

export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  tags: string[];
  latestChapter: string;
  chapters: number;
  status: string;
  updateTime: string;
  hot: number;
  intro: string;
  cover: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: "星夜追光人",
    author: "白鹭青灯",
    category: "热血少年",
    tags: ["冒险", "异能", "成长"],
    latestChapter: "第 128 话 · 归途",
    chapters: 128,
    status: "连载中",
    updateTime: "今天 09:20",
    hot: 9864,
    intro: "被星尘选中的少年，在霓虹都市与失控异能之间寻找归途，每话都在长大。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20book%20cover%20art%20of%20a%20young%20hero%20with%20a%20glowing%20star%20motif%20on%20his%20chest%20standing%20in%20a%20neon%20city%20at%20night%2C%20warm%20coral%20and%20amber%20lighting%2C%20dynamic%20manga%20illustration%2C%20bold%20character%20design%2C%20cinematic%20warm%20tones%2C%20detailed%20anime%20background%2C%20no%20text&width=600&height=800&seq=comic-cover-01&orientation=portrait",
  },
  {
    id: 2,
    title: "山海异闻录",
    author: "南山客",
    category: "奇幻冒险",
    tags: ["神话", "山海经", "妖怪"],
    latestChapter: "第 96 话 · 烛龙初醒",
    chapters: 96,
    status: "连载中",
    updateTime: "今天 08:05",
    hot: 9210,
    intro: "一幅失传的山海图卷，牵出九州众妖的千年秘辛，迷雾一层层揭开。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20art%20depicting%20mystical%20Chinese%20mythical%20creatures%20and%20mountains%20in%20a%20dreamy%20glowing%20landscape%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20traditional%20fantasy%20illustration%20style%2C%20detailed%20anime%20artwork%2C%20atmospheric%20mist%20and%20light%2C%20no%20text&width=600&height=800&seq=comic-cover-02&orientation=portrait",
  },
  {
    id: 3,
    title: "剑与星尘",
    author: "罗刹",
    category: "奇幻冒险",
    tags: ["剑士", "热血", "星际"],
    latestChapter: "第 210 话 · 剑指星辰",
    chapters: 210,
    status: "连载中",
    updateTime: "昨天 22:40",
    hot: 10056,
    intro: "末代剑士在星海之间挥剑前行，誓要斩断笼罩诸界的古老诅咒。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20book%20cover%20of%20a%20determined%20swordsman%20holding%20a%20glowing%20sword%20under%20a%20starry%20twilight%20sky%2C%20warm%20golden%20and%20coral%20tones%2C%20dynamic%20action%20composition%2C%20detailed%20anime%20fantasy%20illustration%2C%20cinematic%20lighting%2C%20no%20text&width=600&height=800&seq=comic-cover-03&orientation=portrait",
  },
  {
    id: 4,
    title: "心跳便利店",
    author: "软糖桃桃",
    category: "恋爱日常",
    tags: ["校园", "青春", "治愈"],
    latestChapter: "第 73 话 · 深夜来电",
    chapters: 73,
    status: "连载中",
    updateTime: "今天 11:12",
    hot: 8547,
    intro: "便利店夜班店员与常客之间的小小心动，藏着整个城市的温柔。",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20manga%20cover%20art%20of%20a%20cheerful%20shop%20assistant%20in%20a%20cozy%20convenience%20store%20at%20golden%20evening%20light%2C%20warm%20coral%20and%20amber%20tones%2C%20slice%20of%20life%20romance%20illustration%2C%20detailed%20anime%20background%2C%20heartwarming%20atmosphere%2C%20no%20text&width=600&height=800&seq=comic-cover-04&orientation=portrait",
  },
  {
    id: 5,
    title: "迷雾档案馆",
    author: "墨镜先生",
    category: "悬疑推理",
    tags: ["推理", "怪谈", "反转"],
    latestChapter: "第 55 话 · 第十一层",
    chapters: 55,
    status: "连载中",
    updateTime: "昨天 20:18",
    hot: 7902,
    intro: "一位见习档案员，在堆满禁忌卷宗的档案馆里，追查被尘封的真相。",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20anime%20manga%20cover%20art%20of%20a%20detective%20standing%20before%20a%20glowing%20archive%20room%20filled%20with%20floating%20papers%2C%20warm%20dim%20amber%20lighting%2C%20moody%20mystery%20illustration%2C%20detailed%20anime%20art%2C%20atmospheric%20depth%2C%20no%20text&width=600&height=800&seq=comic-cover-05&orientation=portrait",
  },
  {
    id: 6,
    title: "热血训练营",
    author: "铁板一郎",
    category: "热血少年",
    tags: ["体育", "燃", "伙伴"],
    latestChapter: "第 142 话 · 决胜一球",
    chapters: 142,
    status: "连载中",
    updateTime: "今天 07:50",
    hot: 8831,
    intro: "一群不被看好的少年，在夕阳下的球场上，用汗水改写自己的剧本。",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20anime%20manga%20cover%20art%20of%20a%20determined%20athlete%20sprinting%20across%20a%20track%20field%20at%20warm%20sunset%2C%20golden%20amber%20and%20coral%20tones%2C%20dynamic%20sports%20illustration%2C%20detailed%20anime%20background%2C%20high%20energy%20composition%2C%20no%20text&width=600&height=800&seq=comic-cover-06&orientation=portrait",
  },
  {
    id: 7,
    title: "上古炼金术士",
    author: "灰烬与火",
    category: "奇幻冒险",
    tags: ["炼金", "魔法", "史诗"],
    latestChapter: "第 118 话 · 贤者之石",
    chapters: 118,
    status: "连载中",
    updateTime: "昨天 21:30",
    hot: 8120,
    intro: "被困在旧王朝废墟里的炼金术士，试图用一块石头撬动整个时代的命运。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20book%20cover%20art%20of%20a%20young%20alchemist%20in%20a%20warm%20glowing%20workshop%20with%20bubbling%20potions%20and%20floating%20runes%2C%20golden%20amber%20and%20coral%20palette%2C%20fantasy%20illustration%2C%20detailed%20anime%20background%20art%2C%20magical%20atmosphere%2C%20no%20text&width=600&height=800&seq=comic-cover-07&orientation=portrait",
  },
  {
    id: 8,
    title: "都市食客",
    author: "一碗热汤",
    category: "美食生活",
    tags: ["美食", "烟火气", "治愈"],
    latestChapter: "第 64 话 · 深夜食堂",
    chapters: 64,
    status: "连载中",
    updateTime: "今天 12:35",
    hot: 7458,
    intro: "跟着小厨娘的餐车，穿梭在深夜的城市，一口热饭治愈一天的疲惫。",
    cover:
      "https://readdy.ai/api/search-image?query=Delicious%20anime%20manga%20cover%20art%20of%20a%20chef%20preparing%20glowing%20street%20food%20at%20a%20warm%20night%20market%2C%20coral%20and%20amber%20lighting%2C%20food%20illustration%2C%20detailed%20anime%20background%2C%20vibrant%20warm%20colors%2C%20mouthwatering%20scene%2C%20no%20text&width=600&height=800&seq=comic-cover-08&orientation=portrait",
  },
];

export const categories = [
  { name: "热血少年", icon: "ri-fire-line", desc: "燃到骨子里的热血旅程", count: 286 },
  { name: "奇幻冒险", icon: "ri-compass-3-line", desc: "穿越山海与星海", count: 194 },
  { name: "恋爱日常", icon: "ri-heart-3-line", desc: "每一话都在心动", count: 237 },
  { name: "悬疑推理", icon: "ri-search-eye-line", desc: "反转不断烧脑上头", count: 121 },
  { name: "美食生活", icon: "ri-restaurant-line", desc: "烟火气里的小确幸", count: 98 },
  { name: "治愈系", icon: "ri-sun-line", desc: "慢慢治愈疲惫的你", count: 156 },
];

export const faqs = [
  {
    q: "怎么收藏自己想追的漫画？",
    a: "在作品卡片或详情页点击「收藏追更」按钮即可。收藏后，每次打开网站都能在你的追更列表里看到最新话进度，新章节上线会第一时间在更新区置顶展示。",
  },
  {
    q: "漫画的连载进度会实时更新吗？",
    a: "会的。每当作品更新最新话，我们会同步刷新连载状态与章节进度，并在「最新更新」板块按更新时间排序，方便你第一时间查看有没有新章节。",
  },
  {
    q: "我追的漫画显示「已完结」，还能看吗？",
    a: "当然可以。已完结的作品会保留全部章节和进度信息，你可以在分类页按状态筛选，随时回看完整连载，收藏列表里也会保留记录。",
  },
  {
    q: "更新提醒是怎么工作的？",
    a: "你收藏的作品一旦有最新话上线，会进入当天的更新队列并置顶展示，同时会在追更列表标注「NEW」提醒，不用再到处翻评论问进度。",
  },
  {
    q: "支持在手机上追更吗？",
    a: "支持。网站做了完整的移动端适配，手机和平板都能顺畅浏览、收藏和查看连载进度，随时随地盯最新话。",
  },
];

export const rankingList = [
  { id: 1, rank: 1, title: "剑与星尘", updateTime: "昨天 22:40", hot: 10056 },
  { id: 2, rank: 2, title: "星夜追光人", updateTime: "今天 09:20", hot: 9864 },
  { id: 3, rank: 3, title: "山海异闻录", updateTime: "今天 08:05", hot: 9210 },
  { id: 4, rank: 4, title: "热血训练营", updateTime: "今天 07:50", hot: 8831 },
  { id: 5, rank: 5, title: "心跳便利店", updateTime: "今天 11:12", hot: 8547 },
  { id: 6, rank: 6, title: "上古炼金术士", updateTime: "昨天 21:30", hot: 8120 },
  { id: 7, rank: 7, title: "迷雾档案馆", updateTime: "昨天 20:18", hot: 7902 },
  { id: 8, rank: 8, title: "都市食客", updateTime: "今天 12:35", hot: 7458 },
];

export const steps = [
  {
    icon: "ri-bookmark-line",
    title: "收藏作品",
    desc: "把正在追的漫画一键收藏，进度自动归档，不会再错过任何一话。",
  },
  {
    icon: "ri-time-line",
    title: "盯紧进度",
    desc: "每次打开都能看到最新话与连载状态，新章节更新与否一目了然。",
  },
  {
    icon: "ri-sparkling-line",
    title: "顺畅追更",
    desc: "最新更新自动置顶提醒，追更体验顺畅，不用再到处翻评论问进度。",
  },
];